export default "__VITE_ASSET__6f036197__"